export default __webpack_public_path__ + "static/media/Ogg-Medium.a428d1ad.woff2";